import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/Auth";

export default function AuthCallback() {
  const ran = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn } = useAuth();

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google", null, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => signIn(data))
      .then(() => navigate("/", { replace: true }))
      .catch(() => navigate("/login", { replace: true }));
  }, [location.hash, navigate, signIn]);

  return null;
}
